import script from "./Sheelon1View.vue?vue&type=script&setup=true&lang=js"
export * from "./Sheelon1View.vue?vue&type=script&setup=true&lang=js"

import "./Sheelon1View.vue?vue&type=style&index=0&id=c2d5ddea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2d5ddea"]])

export default __exports__